import * as React from 'react';

import { cn } from '@apps/web/lib/utils';

/**
 * Minimal determinate progress bar. Value is clamped to [0, 100]; color
 * comes from the parent via className / indicatorClassName.
 */
function Progress({
    className,
    indicatorClassName,
    value,
    ...props
}: React.ComponentProps<'div'> & {
    value: number;
    indicatorClassName?: string;
}) {
    const clampedValue = Math.min(100, Math.max(0, value));
    return (
        <div
            data-slot="progress"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={clampedValue}
            className={cn(
                'bg-muted h-2 w-full overflow-hidden rounded-full',
                className,
            )}
            {...props}
        >
            <div
                data-slot="progress-indicator"
                className={cn(
                    'bg-primary h-full rounded-full transition-all',
                    indicatorClassName,
                )}
                style={{ width: `${clampedValue}%` }}
            />
        </div>
    );
}

export { Progress };
